/**
 * @file Web gallery favorites related queries.
 */

import gql from 'graphql-tag';

import {
  AlbumRootAlbumFolderBaseDetails,
  AlbumWatermarkConfig,
  PhotoUrlTypeFields,
} from '../../../../graphql/fragments/album';
import { WebGalleryAccountDetailsWithImageAssets } from '../fragments/account';
import {
  WebGalleryAlbumBaseDetails,
  WebGalleryAlbumCustomPrintFields,
} from '../fragments/album';
import { PhotoAttribution } from '../fragments/global';
import { PhotoFavoriteDetails } from '../../../../graphql/fragments/photo';

export const AlbumFolderAccountFavoritePhotos = gql`
  query albumFolderAccountFavoritePhotos(
    $id: RecordID!
    $limit: Int = 9999
    $offset: Int = 0
  ) {
    albumFolder(id: $id) {
      id
      account {
        ...WebGalleryAccountDetailsWithImageAssets
      }
      account_favorite_photos(slice: { limit: $limit, offset: $offset }) {
        total
        count
        records {
          id
          photo {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
            watermarked_urls {
              ...PhotoUrlTypeFields
            }
            ...PhotoAttribution
            share_blocked
            album {
              id
            }
            is_owner
            ...PhotoFavoriteDetails
          }
          album {
            id
            ...WebGalleryAlbumBaseDetails
            ...WebGalleryAlbumCustomPrintFields
            ...AlbumWatermarkConfig
            ...AlbumRootAlbumFolderBaseDetails
            web_gallery_print_purchases_enabled
            collages: custom_prints(custom_print_types: [COLLAGE]) {
              total
            }
            creator {
              id
              name
              organization_name
            }
          }
        }
      }
    }
  }
  ${WebGalleryAccountDetailsWithImageAssets}
  ${WebGalleryAlbumCustomPrintFields}
  ${WebGalleryAlbumBaseDetails}
  ${AlbumWatermarkConfig}
  ${PhotoUrlTypeFields}
  ${PhotoAttribution}
  ${AlbumRootAlbumFolderBaseDetails}
  ${PhotoFavoriteDetails}
`;

export const AlbumAccountFavoritePhotos = gql`
  query albumAccountFavoritePhotos(
    $id: RecordID!
    $limit: Int = 9999
    $offset: Int = 0
  ) {
    album(id: $id) {
      id
      creator {
        ...WebGalleryAccountDetailsWithImageAssets
      }
      account_favorite_photos(slice: { limit: $limit, offset: $offset }) {
        total
        count
        records {
          id
          photo {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
            watermarked_urls {
              ...PhotoUrlTypeFields
            }
            share_blocked
            is_owner
            ...PhotoFavoriteDetails
          }
        }
      }
      ...WebGalleryAlbumBaseDetails
      ...WebGalleryAlbumCustomPrintFields
      ...AlbumWatermarkConfig
      ...AlbumRootAlbumFolderBaseDetails
    }
  }
  ${WebGalleryAccountDetailsWithImageAssets}
  ${WebGalleryAlbumBaseDetails}
  ${WebGalleryAlbumCustomPrintFields}
  ${AlbumWatermarkConfig}
  ${PhotoUrlTypeFields}
  ${AlbumRootAlbumFolderBaseDetails}
  ${PhotoFavoriteDetails}
`;

export const AlbumPhotoGroupFavoritePhotoIds = gql`
  query albumPhotoGroupFavoritePhotoIds($id: RecordID!, $limit: Int = 9999) {
    albumPhotoGroup(id: $id) {
      id
      account_favorite_photos(slice: { limit: $limit }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
    }
  }
`;

export const AlbumFavoritePhotoIds = gql`
  query albumFavoritePhotoIds($id: RecordID!, $limit: Int = 9999) {
    album(id: $id) {
      id
      account_favorite_photos(slice: { limit: $limit }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
    }
  }
`;

export const AlbumFolderFavoritePhotoIds = gql`
  query albumFolderFavoritePhotoIds($id: RecordID!, $limit: Int = 9999) {
    albumFolder(id: $id) {
      id
      account_favorite_photos(slice: { limit: $limit }) {
        total
        records {
          id
          photo {
            id
          }
        }
      }
    }
  }
`;
